import { Injectable } from "@angular/core"
import { environment } from "../../../../environments/environment"
import { HttpClient } from "@angular/common/http"

@Injectable()
export class FeatureFlagsService {
  private get_feature_flags_url: string

  constructor(private httpClient: HttpClient) {
    this.get_feature_flags_url =
      environment.endpointFeatureFlags.url +
      environment.endpointFeatureFlags.routes.get_feature_flags
  }

  getFeatureFlags() {
    return this.httpClient.get(this.get_feature_flags_url)
  }
}
